import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required("Title can not be empty")
    .min(5, "Title can not be less that 5 letters")
    .max(225, "Title can not be less that 225 letters")
    .matches(/^[a-zA-Z_ , .]+$/, "Report Title Can Not Contain Special Characters")
    .label("Title"),

  desc: Yup.string()
    .required("Description can not be empty")
    .min(15, "Description can not be less that 15 letters")
    .matches(/^[a-zA-Z_ , .]+$/, "Report Description Can Not Contain Special Characters")
    .max(225, "Description can not be less that 225 letters"),
});

export const initialValues = {
  title: "",
  desc: "",
};
